import { DeploymentProviders } from "utils/deployment-providers-util";
import { IHasOwner, IIdName, IIdNameDateTime } from "./id-name";
import { IDeletedParam, IQueryStrictParams, IRequestParams } from "./page";
import { IShardRepository } from "./shard-repository";

export interface IStorageNodeProvider
  extends IIdNameDateTime<string>,
    IHasOwner {
  provider: DeploymentProviders;
  accessKeyId: string;
  accessKeySecret: string;
  default: boolean;
  storageNodes?: IShardRepository[];
}

export interface IStorageNodeProviderDetailItem
  extends Omit<IStorageNodeProvider, "storageNodes"> {
  storageNodes: IIdName<string>[];
}

export interface IStorageNodeProviderCreateRequest
  extends Pick<
    IStorageNodeProvider,
    "name" | "provider" | "default" | "accessKeyId" | "accessKeySecret"
  > {
  id?: string;
}
export interface IStorageNodeProviderUpdateRequest
  extends Partial<Omit<IStorageNodeProviderCreateRequest, "id">> {}
  
export interface IStorageNodeProviderListItem
  extends Pick<IStorageNodeProvider, "id" | "name" | "provider" | "default"> {}

export enum StorageNodeProviderSortField {
  Id = "id",
  Name = "name",
  Provider = "provider",
}

export interface IStorageNodeProviderLightFilterParams {
    q?: string,
}

export interface IStorageNodeProviderFilterParams extends IQueryStrictParams {
  default?: boolean;
  storageNodes?: string[];
}

export interface IStorageNodeProviderFind
  extends IRequestParams<StorageNodeProviderSortField>,
    IStorageNodeProviderFilterParams,
    IDeletedParam {
  fields?: (keyof IStorageNodeProvider)[];
}
